import { render } from "./organizer-input.vue?vue&type=template&id=2b23d8f8&lang=pug"
import script from "./organizer-input.vue?vue&type=script&setup=true&lang=js"
export * from "./organizer-input.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__